var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-item",class:{'active': _vm.index == 0}},[_c('div',{staticClass:"w-100 img",style:({'background-image': 'url('+_vm.$domain+_vm.path(_vm.item.photo)+')'})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e13870","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/CarouselItem.vue
// module id = 53
// module chunks = 0